import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  List,
  ListItemText,
  ListItemIcon,
  Box,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import HistoryIcon from "@material-ui/icons/History";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import SyncIcon from "@material-ui/icons/Sync";
import CreateIcon from "@material-ui/icons/Create";

const useStyles = makeStyles((theme) => ({
  dialogTitle: {
    backgroundColor: theme.palette.primary.main,
    color: "white",
  },
  dialogContent: {
    padding: theme.spacing(3),
    minWidth: 400,
    maxHeight: 500,
  },
  timelineItem: {
    display: "flex",
    position: "relative",
    paddingBottom: theme.spacing(3),
    "&:last-child": {
      paddingBottom: 0,
    },
  },
  timelineConnector: {
    position: "absolute",
    top: 24,
    left: 20,
    bottom: 0,
    width: 2,
    backgroundColor: theme.palette.grey[300],
  },
  timelineIcon: {
    minWidth: 40,
    zIndex: 1,
  },
  timelineDot: {
    width: 32,
    height: 32,
    borderRadius: "50%",
    backgroundColor: theme.palette.primary.light,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "white",
  },
}));

const ActivityLogDialog = ({ open, onClose, auditLogs }) => {
  const classes = useStyles();

  // Parse logs safely
  const parseLogs = (logs) => {
    if (!logs) return [];
    try {
      // If it's a JSON array
      const parsed = JSON.parse(logs);
      if (Array.isArray(parsed)) return parsed;
    } catch (e) {
      // Ignore and handle as string
    }

    // Split newline-separated string
    if (typeof logs === "string") {
      return logs.split("\n").filter((log) => log.trim() !== "");
    }
    return [];
  };

  const logList = parseLogs(auditLogs);

  const getIcon = (logText) => {
    const text = logText.toLowerCase();
    if (text.includes("create") || text.includes("สร้าง")) {
      return <CreateIcon fontSize="small" />;
    }
    if (text.includes("sync") || text.includes("ซิงก์") || text.includes("draft")) {
      return <SyncIcon fontSize="small" />;
    }
    if (text.includes("commit") || text.includes("บันทึกจบ") || text.includes("เสร็จสิ้น")) {
      return <CheckCircleIcon fontSize="small" />;
    }
    return <HistoryIcon fontSize="small" />;
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle className={classes.dialogTitle}>Activity Log / Timeline</DialogTitle>
      <DialogContent className={classes.dialogContent} dividers>
        {logList.length === 0 ? (
          <Box display="flex" justifyContent="center" alignItems="center" p={3}>
            <Typography variant="body2" color="textSecondary">
              No activity logs available for this document.
            </Typography>
          </Box>
        ) : (
          <List disablePadding>
            {logList.map((log, index) => {
              const logText = typeof log === "object" ? log.message || log.Message || JSON.stringify(log) : log;
              return (
                <div key={index} className={classes.timelineItem}>
                  {index < logList.length - 1 && <div className={classes.timelineConnector} />}
                  <ListItemIcon className={classes.timelineIcon}>
                    <div className={classes.timelineDot}>
                      {getIcon(logText)}
                    </div>
                  </ListItemIcon>
                  <ListItemText
                    primary={logText}
                    secondary={typeof log === "object" && (log.timestamp || log.Timestamp) ? log.timestamp || log.Timestamp : ""}
                  />
                </div>
              );
            })}
          </List>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" variant="contained">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ActivityLogDialog;
